import { ColumnDataTypeEnum } from '@datum-group/isogd-openapi/lib';

const emailRegExp = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
const urlRegExp = /((?:https?|ftp)\S*)/gi;

const isNumberOrString = (value: unknown): value is number | string => {
  return typeof value === 'number' || typeof value === 'string';
};

export enum VarCharElementType {
  email = 'email',
  url = 'url',
  text = 'string',
}
export interface VarCharElement {
  value: string;
  type: VarCharElementType;
}

export interface Render {
  emptyRender(): any;
  trueRender(): any;
  falseRender(): any;
  referencesRender(table: string, record: string | number): any;
  dateRender(date: string): any;
  timeStampRender(date: string): any;
  varCharRender(data: VarCharElement[]): any;

  /** Рендер по умолчанию. */
  textRender(text: string): any;
}

export class RecordFieldFormatter {
  private _render: Render;

  constructor(render: Render) {
    this._render = render;
  }

  formatValue = (
    type: ColumnDataTypeEnum,
    value: any,
    references: string | null | undefined,
  ) => {
    if (
      references &&
      type === ColumnDataTypeEnum.Integer &&
      isNumberOrString(value)
    ) {
      return this._render.referencesRender(references, value);
    }

    if (
      type === ColumnDataTypeEnum.Blob ||
      type === ColumnDataTypeEnum.Geometry
    )
      return this._render.emptyRender();

    if (value === undefined || value === null)
      return this._render.emptyRender();

    if (type === ColumnDataTypeEnum.Boolean) {
      return value ? this._render.trueRender() : this._render.falseRender();
    }

    if (type === ColumnDataTypeEnum.TimeStamp) {
      return this._render.timeStampRender(new Date(value).toLocaleString());
    }

    if (type === ColumnDataTypeEnum.Date) {
      return this._render.dateRender(
        new Date(value).toLocaleString().split(',')[0] || '' + value,
      );
    }

    if (type === ColumnDataTypeEnum.VarChar) {
      return this._render.varCharRender(this._replaceLink(value));
    }

    return this._render.textRender(`${value}`);
  };

  private _replaceLink = (str: string) => {
    const urls = this._replaceURL(str);

    const result: VarCharElement[] = [];

    urls.forEach((elem) => {
      if (elem.type === VarCharElementType.text) {
        const emails = this._replaceEmail(elem.value);

        result.push(...emails);
      } else {
        result.push(elem);
      }
    });

    return result;
  };

  // Возвращает true, если строка содержит 'http:', 'https:' или 'ftp:'
  private _checkForPrefix = (target: string) => {
    if (
      target.includes('http:') ||
      target.includes('https:') ||
      target.includes('ftp:')
    ) {
      return true;
    } else {
      return false;
    }
  };

  private _replaceURL = (strToCheck: string): VarCharElement[] => {
    return strToCheck.split(urlRegExp).map((word) => {
      if (this._checkForPrefix(word)) {
        let href = word;

        if (word.endsWith('.') || word.endsWith(',')) {
          href = word.slice(0, -1);
        }

        return { type: VarCharElementType.url, value: href };
      } else {
        return { type: VarCharElementType.text, value: word };
      }
    });
  };

  private _replaceEmail = (str: string): VarCharElement[] => {
    const arr = str.split(emailRegExp);

    return arr.map((elem) => {
      if (emailRegExp.test(elem)) {
        return { type: VarCharElementType.email, value: elem };
      }

      return { type: VarCharElementType.text, value: elem };
    });
  };
}
